// CustomizedCareSection.js
import React from "react";

const CustomizedCareSection = () => {
  return (
    <section className="py-16 px-6 md:px-12 lg:px-24 bg-gray-100">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
          Customised In-Home Elder Care Services in the Riverina
        </h2>

        <div className="space-y-4 text-gray-700 font-light leading-relaxed">
          <p>
            At Allawah Lodge, we realise that every one of our clients is
            unique. That's why we develop a personalised in-home care plan
            customised to each person's specific needs. Regardless of which
            in-home services you need, from a few hours per week to
            around-the-clock care, you can be confident you or your loved one
            will receive the nurturing they deserve. Understanding that needs
            often change, we offer a broad range of in-home health care services
            and flexible scheduling options, enabling us to respond quickly
            while putting an updated care plan into action for our clients as
            needed. We also recognise that good communication is the key to good
            customer service.
          </p>

          <p>
            Our supervisory staff is in regular contact with our clients and
            caregivers to ensure information is shared in an accurate and timely
            manner. In addition to being well-trained and fully qualified, each
            Allawah Lodge caregiver must also pass a rigorous background check.
            Along with having a caregiver who genuinely cares, you will have
            peace of mind knowing you can contact an on-call nurse supervisor
            any time of day or night.
          </p>

          <p className="font-normal">
            Delivered when and where you need them, our dependable Home Care
            Services include the following:
          </p>
        </div>
      </div>
    </section>
  );
};

export default CustomizedCareSection;
